import { Component } from 'react';
import firebase from '../tools/firebase';
import { withRouter } from 'react-router';
import { Container, Tabs, Tab, Card } from 'react-bootstrap';
import { FaFacebookF, FaInstagram, FaTwitter, FaGlobe } from 'react-icons/fa';
import Footer from './Footer';
import style from '../style/truckPage_ui.module.css';

class TruckPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			truckId: '',
			truckInfo: null,
			truckHeroImgURL: '',
			comments: [],
			socialMedia: [],
			facebook: null,
			instagram: null,
			twitter: null,
			website: null,
			desserts: [],
			extras: [],
			entrees: [],
			drinks: [],
			isLoading: true,
			error: null,
			awards: [],
		};
	}

	componentDidMount() {
		const id = this.props.match.params.truckId;
		this.setState({ truckId: id });

		const db = firebase.firestore();

		db.collection('trucks').doc(id).get()
			.then((doc) => {
				if (!doc.exists) {
					this.setState({ isLoading: false, error: 'Truck not found.' });
					return;
				}
				const truckData = doc.data();
				const social = truckData.socialmedia || [];
				this.setState({
					truckInfo: truckData,
					truckHeroImgURL: truckData.image || '',
					socialMedia: social,
					facebook:  social.find(a => a.key === 'facebook')  || null,
					instagram: social.find(a => a.key === 'instagram') || null,
					twitter:   social.find(a => a.key === 'twitter')   || null,
					website:   social.find(a => a.key === 'website')   || null,
					isLoading: false,
				});
			})
			.catch(() => this.setState({ isLoading: false, error: 'Could not load truck data.' }));

		db.collection('comments').where('truckID', '==', id).get()
			.then((snap) => {
				const commentArray = [];
				snap.forEach(doc => commentArray.push(doc.data()));
				this.setState({ comments: commentArray });
			})
			.catch(() => {});

		db.collection('trucks').doc(id).collection('awards').get()
			.then(snap => {
				const list = [];
				snap.forEach(doc => list.push({ id: doc.id, ...doc.data() }));
				list.sort((a, b) => (b.year || '').localeCompare(a.year || ''));
				this.setState({ awards: list });
			})
			.catch(() => {});

		const menuCollections = ['Entrees', 'Desserts', 'Drinks', 'Extras'];
		const stateKeys      = ['entrees', 'desserts', 'drinks', 'extras'];
		menuCollections.forEach((col, i) => {
			db.collection('trucks').doc(id).collection(col).get()
				.then((snap) => {
					const items = [];
					snap.forEach(doc => { const d = doc.data(); if (d.active !== false) items.push(d); });
					this.setState({ [stateKeys[i]]: items });
				})
				.catch(() => {});
		});
	}

	renderMenuCards(items) {
		if (!items || items.length === 0) {
			return (
				<div className={style.emptyState}>
					<p>Nothing here yet</p>
				</div>
			);
		}
		return (
			<div className={style.wrapper}>
				{items.map((food, index) => (
					<Card className={style.item} key={index}>
						{food.image && (
							<Card.Img variant="top" className={style.cardImg} src={food.image} />
						)}
						<Card.Body className={style.cardBody}>
							<Card.Title className={style.cardTitle}>{food.name}</Card.Title>
							{food.description && (
								<p className={style.cardDescription}>{food.description}</p>
							)}
							{food.price != null && food.price !== '' && (
								<span className={style.cardPrice}>
									{parseFloat(food.price) === 0 ? 'Free' : `$${food.price}`}
									{food.gtamount ? ` / ${food.gtamount}` : ''}
								</span>
							)}
						</Card.Body>
					</Card>
				))}
			</div>
		);
	}

	render() {
		const { isLoading, error, truckInfo, truckHeroImgURL,
			facebook, instagram, twitter, website,
			entrees, desserts, drinks, extras, comments, awards } = this.state;

		if (isLoading) {
			return (
				<div className={style.loadingContainer}>
					<div className={style.spinner} />
					<p>Loading…</p>
				</div>
			);
		}

		if (error) {
			return (
				<div className={style.loadingContainer}>
					<p className={style.errorText}>{error}</p>
				</div>
			);
		}

		const socialLinks = [
			{ account: facebook,  Icon: FaFacebookF },
			{ account: instagram, Icon: FaInstagram },
			{ account: twitter,   Icon: FaTwitter   },
			{ account: website,   Icon: FaGlobe     },
		];

		return (
			<div className={style.pageWrapper}>
				{/* Hero */}
				<div
					className={style.hero}
					style={{ backgroundImage: truckHeroImgURL ? `url(${truckHeroImgURL})` : 'none' }}
				>
					<div className={style.heroOverlay} />

					<div className={style.socialBar}>
						<Container className={style.socialBarInner}>
							{socialLinks.map(({ account, Icon }, i) =>
								account?.link ? (
									<a
										key={i}
										href={account.link}
										className={style.socialLink}
										target="_blank"
										rel="noopener noreferrer"
									>
										<Icon />
									</a>
								) : (
									<span key={i} className={`${style.socialLink} ${style.socialLinkDisabled}`}>
										<Icon />
									</span>
								)
							)}
						</Container>
					</div>

					{truckInfo?.title && (
						<div className={style.heroTitle}>
							<Container>
								<h1>{truckInfo.title}</h1>
							</Container>
						</div>
					)}
				</div>

				<Container className={style.pageContent}>
					{truckInfo?.description && (
						<p className={style.description}>{truckInfo.description}</p>
					)}

					{awards.length > 0 && (
						<div className={style.awardsSection}>
							<h5 className={style.awardsHeading}>Awards &amp; Recognition</h5>
							<div className={style.awardsList}>
								{awards.map(award => (
									<div key={award.id} className={style.awardChip}>
										<span className={style.awardChipIcon}>&#127942;</span>
										<div>
											<div className={style.awardChipTitle}>{award.title}</div>
											{(award.issuer || award.year) && (
												<div className={style.awardChipMeta}>
													{[award.issuer, award.year].filter(Boolean).join(' · ')}
												</div>
											)}
										</div>
									</div>
								))}
							</div>
						</div>
					)}

					{/* Menu tabs — only render tabs that have data */}
					{[entrees, desserts, drinks, extras].some(a => a.length > 0) && (
					<Tabs
						fill
						defaultActiveKey={['entrees','desserts','drinks','extras'].find(
							k => ({ entrees, desserts, drinks, extras })[k].length > 0
						)}
						className={style.tabMain}
					>
						{entrees.length  > 0 && <Tab eventKey="entrees"  title="Entrees" >{this.renderMenuCards(entrees)}</Tab>}
						{desserts.length > 0 && <Tab eventKey="desserts" title="Desserts">{this.renderMenuCards(desserts)}</Tab>}
						{drinks.length   > 0 && <Tab eventKey="drinks"   title="Drinks"  >{this.renderMenuCards(drinks)}</Tab>}
						{extras.length   > 0 && <Tab eventKey="extras"   title="Extras"  >{this.renderMenuCards(extras)}</Tab>}
					</Tabs>
					)}

					<div className={style.reviewSection}>
						<h5 className={style.reviewHeading}>Reviews</h5>
						{comments.length === 0 ? (
							<p className={style.noReviews}>No reviews yet</p>
						) : (
							comments.map((data, i) => (
								<div className={style.reviewCard} key={i}>
									<div className={style.reviewHeader}>
										<span className={style.reviewerName}>{data.userName}</span>
										<span className={style.reviewDate}>{data.dateofcomment}</span>
									</div>
									<p className={style.reviewText}>{data.comment}</p>
								</div>
							))
						)}
					</div>
				</Container>
				<Footer />
			</div>
		);
	}
}

export default withRouter(TruckPage);
